/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// import { Add  } from "@mui/icons-material";
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from "@mui/material";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from "axios";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from 'components/Icon/TimelineItem';
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import { format } from 'date-fns';
import VisaCard from 'examples/Cards/VisaCard/VisaCard';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from 'examples/PageTitle/PageTitle';
import CheckoutForm from 'examples/checkouform/checkoutForm';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cancelSubscriptionPlan, cardDelete, changeToBasicPlan, changeToSubscriptionPlan, getCards, getCurrentPlanDetails, getPaymentIntent, getSubscriptionPlans, paymentWithSavedCard, updateDefaultCard } from "utils/api";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, getSesstionDataByUserID, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import { loadingAction } from "ReduxReducers/loadingReducer";
import useFeatureAccess from "utils/useFeatureAccess";
import { validateField } from "utils/generic";
import PLAN from "../../assets/images/plans.jpg"
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
const stripePromise = loadStripe('pk_test_51HrNQVBpGJwctgBno7AIGt6ZHiDRgfWXv31tA479s6GKXByzHbbwyU2Krw4Xaa5vE0CLVryIlJiy26n5PVENCr1s000ssvA0av');
const errMsg = {
    color: `red`,
    fontSize: `11px`,
};
let LOGIN_DETAILS;
function BillingScreen() {
    const featureAccess = useFeatureAccess();
    const navigate = useNavigate();

    const [screenName, setScreenName] = useState("Billing");
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [plans, setPlans] = useState([]);
    const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
    const [defaultDialogeFlag, setDefaultDialogeFlag] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [customerReload, setCustomerReload] = useState(false);
    const [showPaymentGateway, setShowPaymenttGateway] = useState(false)
    const [showPricingPlan, setShowPricingPlan] = useState(false)
    const [paymentIntent, setPaymentIntent] = useState(false)
    const [planID, setPlanID] = useState("");
    const [oldPlanID, setOldPlanID] = useState("");
    const [businessPlan, setBusinessPlanID] = useState("");
    const [plansList, setPlansList] = useState([])
    const [amount, setAmount] = useState("");
    const [showCredit, setShowCredit] = useState(false);
    const [mainUi, setMAinUi] = useState(true);
    const [paymentMethodUi, setPaymentMethodUi] = useState(false)
    const [creditPerBuy, setCreditPerBuy] = useState(0);
    const [creditCalculated, setCreditCalculated] = useState(0);
    const [transactionType, setTransactionType] = useState("");
    const [cancelPlanUIVisibility, setCancelPlanUIVisibility] = useState(false);
    const [planCancellationEffectiveDate, setPlanCancellationEffectiveDate] = useState("");
    const [cancellationRequest, setCancellationRequest] = useState("");
    const [disableColor, setDisableColor] = useState(false);
    const [showChangePlan, setShowChangePLan] = useState(false);
    const dispatch = useDispatch()


    const [cardHolderNameErr, setCardHolderNameErr] = useState(false);
    const [cardNumberErr, setCardNumberErr] = useState(false);
    const [expiryMonthErr, setExpiryMonthErr] = useState(false);
    const [expiryYearErr, setExpiryYearErr] = useState(false);
    const [cardCvvErr, setCardCvvErr] = useState(false);

    const [subscriptionCanNoteErr, setSubscriptionCanNoteErr] = useState(false);

    const [values, setValues] = React.useState({
        customerID: "",
        phoneNumber: "+61",
        paymentType: "Self-Payment",
        firstName: "",
        lastName: "",
        planID: "",
        emailAddress: "",
        streetAddress: "",
        city: "",
        zipCode: "",
        businessID: "",
        businessName: "",
        countryId: "",
        stateId: "",
        customerType: "Individual",
        receiverfirstName: "",
        receiverlastName: "",
        receiverContactNumber: "+61",
        receiverStreetAddress: "",
        receiverCity: "",
        receiverZipCode: "",
        receiverCountryID: "",
        receiverStateID: "",
        shipmentType: "Sender Location Pickup",
        pickupWarehouseID: null,
        accountNumber: "",
        selectUser: "Existing",
        currentPlanID: "",
        planMonthlyCost: "",
        businessUserPlanID: "",
        planCancellationRequestDate: format(new Date(new Date()), 'LLL dd, yyyy'),
        businessUserID: "",

    });
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
    values.id = LOGIN_DETAILS.businessUserID;
    const [details, setDetails] = React.useState({});
    const [values1, setValues1] = React.useState({
        cardType: "saveCard",
    });

    const [openPlans, setOpenPlans] = useState(false);

    const handleOpen = () => {
        setOpenPlans(true);
    };

    const handleClose = () => {
        setOpenPlans(false);
    };

    const isPlanDegrade = (selectedPlanID) => {
        const currentPlanName = details.planName;
        if (currentPlanName === "Platinum") {
            return true
        }
        else if (currentPlanName === "Gold") {
            const selectedPlanName = plans.find(item => item._id == selectedPlanID).planName;
            if (selectedPlanName === "Silver") {
                return true
            }
        }
        return false;
    }
    const [pendingPlanID, setPendingPlanID] = useState("");  // Temporary storage for the selected value

    const handleChangePlan = (name) => (event) => {
        if (name === "planID") {
            const SelectedPlanID = event.target.value;
            const isDegradePlan = isPlanDegrade(SelectedPlanID);

            setPendingPlanID(SelectedPlanID);  // Store the selected plan, but don't change the displayed value yet

            if (isDegradePlan) {
                ShowSwalWithButtons(
                    `You are about to downgrade the Plan. Your current plan expires on ${details?.planExpiryDate}`,
                    `Note: We do not have any refund policy.<br><br>Do you still want to downgrade the Plan?`,
                    'warning',
                    darkMode,
                    // If confirmed
                    () => {
                        setValues({ ...values, [name]: SelectedPlanID });  // Update planID and show in dropdown
                        setPendingPlanID("");  // Clear the pending plan state
                    },
                    // If canceled
                    () => {
                        setPendingPlanID("");  // Clear pending plan state without updating the value
                    }
                );
            } else {
                // If it's not a downgrade, directly update the planID
                setValues({ ...values, [name]: SelectedPlanID });
            }
        }
    };
    const handleChange = (name) => (event) => {

        if (name === "cardNumber") {
            let value = event.target.value.replace(/\D/g, '');
            value = value.slice(0, 16);

            if (value.length > 4) {
                value = value.slice(0, 4) + ' ' + value.slice(4);
            }
            if (value.length > 9) {
                value = value.slice(0, 9) + ' ' + value.slice(9);
            }
            if (value.length > 14) {
                value = value.slice(0, 14) + ' ' + value.slice(14);
            }
            setValues({ ...values, [name]: value });
        }
        else if (event.target.validity?.valid === undefined || event.target.validity.valid) {
            setValues({ ...values, [name]: event.target.value });
        }
    };
    const handleChange1 = (name) => (event) => {
        setValues1({ ...values1, [name]: event.target.value });
    };
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    useEffect(() => {
        Promise.all([
            fetchPlan(),
            fetchCard(),
            fetchCurrentPlanDetails(),
            getRight(),
        ])
        setShowChangePLan(false);
        setMAinUi(true)
        setShowCredit(false)
        setScreenName("Subscriptions")
        setPaymentIntent(false)
        setShowPaymenttGateway(false)
        setCancelPlanUIVisibility(false)
    }, [customerReload, dispatch])

    const getRight = async () => {
        let right = await getScreenRight("Subscriptions");
        console.log("SCREEN_RIGHT", right)
        if (right === "Full Access") {
            setDisableColor(false)
        }
        else { setDisableColor(true) }
    }
    const fetchPlan = async () => {
        getSubscriptionPlans(async (data) => {
            setPlans(data.Result_Output);
            // setPlansList(await generateDataList(data.Result_Output, "_id", "planName", values?.currentPlanID))
        })
        setLoading(true);
    };
    useEffect(async () => {
        if (values.currentPlanID && plans.length > 0) {
            setPlansList(await generateDataList(plans, "_id", "planName", values?.currentPlanID))
        }
    }, [plans, values?.currentPlanID])
    const fetchCard = async () => {
        getCards(values, (data) => {
            setRows(data.Result_Output);
        }, dispatch)
    };
    const clearErrorStates = () => {

        setCardHolderNameErr(false);
        setCardNumberErr(false);
        setExpiryMonthErr(false);
        setExpiryYearErr(false);
        setCardCvvErr(false);
        setSubscriptionCanNoteErr(false);
    };
    const fetchCurrentPlanDetails = async () => {
        getCurrentPlanDetails(values, (data) => {
            setBusinessPlanID(data.Result_Output.currentPlanDetails[0].businessUserPlanID)
            setValues(data.Result_Output.currentPlanDetails[0])
            setDetails(data.Result_Output.currentPlanDetails[0])
            setOldPlanID(data.Result_Output.currentPlanDetails[0].currentPlanID)
            if (data.Result_Output.currentPlanDetails[0].planCancellationEffectiveDate !== "" && data.Result_Output.currentPlanDetails[0].planCancellationEffectiveDate !== undefined)
                setPlanCancellationEffectiveDate(format(new Date(data.Result_Output.currentPlanDetails[0].planCancellationEffectiveDate), 'LLL dd, yyyy'))
            if (data.Result_Output.currentPlanDetails[0].planCancellationReqeustDate !== "" && data.Result_Output.currentPlanDetails[0].planCancellationReqeustDate !== undefined)
                setCancellationRequest(format(new Date(data.Result_Output.currentPlanDetails[0].planCancellationReqeustDate), 'LLL dd, yyyy'))
            setCreditPerBuy(data.Result_Output.credit[0].featureCount)
        }, dispatch)
    };

    useEffect(() => {
        if (values.planID !== "" && values.planID !== undefined) {
            setPlanID(values.planID)
        }
        for (let plan of plans) {
            if (plan._id === values.planID) {
                setValues((prevState) => ({
                    ...prevState,
                    _id: plan._id,
                    planName: plan.planName,
                    planMonthlyCost: plan.planMonthlyCost

                }));
                setAmount(plan.planMonthlyCost)
            }
        }
    }, [values.planID])

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get('payment_intent')
        const paramValue1 = urlParams.get('planID')
        const paramValue2 = urlParams.get('PlanName')
        const paramValue3 = urlParams.get('OldPlanID')
        const paramValue4 = urlParams.get('TransactionType')
        if (paramValue4 === "AddCredit") {
            values.paymentType = "Add Credit"
        }
        if (paramValue2 !== "" && paramValue2 !== undefined && paramValue2 !== null) {
            values.planName = paramValue2
        }
        if (paramValue3 !== "" && paramValue3 !== undefined && paramValue3 !== null) {
            values.businessUserPlanID = paramValue3
            values.oldBusinessUserPlanID = paramValue3
        }
        if (paramValue1 !== "" && paramValue1 !== undefined && paramValue1 !== null) {
            values.planID = paramValue1
        }
        if (paramValue !== "" && paramValue !== undefined && paramValue !== null) {
            values.paymentIntentMethodID = paramValue
            changeSubscriptionPlan()
        }

    }, [])
    const changeSubscriptionPlan = async () => {

        changeToSubscriptionPlan(values, async (data) => {
            showResMsg(data.Result_Message, 2000, data.Result_Status, navigate, '/subscriptions');
            await getSesstionDataByUserID(LOGIN_DETAILS?._id)
            fetchCurrentPlanDetails()
            setTimeout(() => {
                window.location.reload()
            }, 1000)

        }, dispatch)
        setLoading(true);

    };

    const changeToTrial = async () => {

        values.planID = planID
        if (showCredit) {
            values.planMonthlyCost = creditCalculated
            values.paymentType = "Add Credit"
            if (values.noOfCredits === "" || values.noOfCredits === undefined || parseInt(values.noOfCredits) === 0) {
                showResMsg("Credit cant be Null or Zero", 2000, false);
                return

            }
            if (parseInt(values.noOfCredits) > 2000) {
                showResMsg("Credit cant be more then  2000", 2000, false);
                return
            }
        } else {
            values.paymentType = "Subcription"
            if (values.planID === "" || values.planID === undefined) {
                showResMsg("Please select atleast One", 2000, false);
                return
            }
            if (values.planID === oldPlanID) {
                showResMsg("Please select different Plan", 2000, false);
                return
            }

        }
        // return console.log("values", values);
        values.userID = LOGIN_DETAILS?._id
        changeToBasicPlan(values, async (data) => {
            showResMsg(data.Result_Status ? genericMessage.subcriptionChanged : data.Result_Message, data.Result_Message, 2000, data.Result_Status,);
            await getSesstionDataByUserID(LOGIN_DETAILS?._id)
            setCustomerReload(!customerReload)
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }, dispatch)

    };



    const generatePaymentIntent = async () => {

        values.planID = planID;
        values.userID = LOGIN_DETAILS?._id
        if (showCredit) {
            values.planMonthlyCost = creditCalculated
            values.paymentType = "Add Credit"
            if (values.noOfCredits === "" || values.noOfCredits === undefined || parseInt(values.noOfCredits) === 0) {
                showResMsg("Credit cant be Null or Zero", 2000, false);
                return
            }
            if (parseInt(values.noOfCredits) > 2000) {
                showResMsg("Credit cant be more then  2000", 2000, false);
                return
            }
        } else {
            values.paymentType = "Subcription"
            if (values.planID === "" || values.planID === undefined) {
                showResMsg("Please select atleast one", 2000, false);
                return
            }
            if (values.planID === oldPlanID) {
                showResMsg("Please select different Plan", 2000, false);
                return
            }

        }

        getPaymentIntent(values, (data) => {
            setPaymentIntent(data.Result_Output)
            setShowPaymenttGateway(true)
        }, dispatch)
    };


    const exit = async () => {
        setMAinUi(true)
        setShowCredit(false)
        setShowChangePLan(false)
        setPaymentMethodUi(false)
        setCancelPlanUIVisibility(false);

        setCardHolderNameErr(false)
        setCardNumberErr(false);
        setExpiryMonthErr(false);
        setExpiryYearErr(false);
        setCardCvvErr(false);
        setSubscriptionCanNoteErr(false);

        setValues((prevValues) => ({
            ...prevValues,
            cardCvv: "",
            expiryYear: "",
            expiryMonth: "",
            cardNumber: "",
            cardHolderName: "",
            noOfCredits: "",
            planID: "",
            planMonthlyCost: "",
            planCancellationNotes: "",
        }));
    };

    const payWithSavedCard = async () => {
        values.planMonthlyCost = amount
        values.businessUserPlanID = businessPlan
        if (values.paymentType === "Add Credit") {
            values.planID = oldPlanID
            values.planMonthlyCost = creditCalculated
        }
        values.userID = LOGIN_DETAILS?._id
        paymentWithSavedCard(values, async (data) => {
            await getSesstionDataByUserID(LOGIN_DETAILS?._id)
            showResMsg(data.Result_Message, 2000, data.Result_Status);
            setCustomerReload(!customerReload)
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }, dispatch)

    };

    const cancelPlan = async () => {
        let mandateFlag = false;
        clearErrorStates();
        mandateFlag = validateField(values.planCancellationNotes, setSubscriptionCanNoteErr) || mandateFlag;
        values.planID = planID
        if (mandateFlag) {
            return
        }
        cancelSubscriptionPlan(values, async (data) => {
            showResMsg(data.Result_Status ? genericMessage.subscriptionCancelled : data.Result_Message, 2000, data.Result_Status);
            if (data.Result_Status) {
                setCustomerReload(!customerReload)
                await getSesstionDataByUserID(LOGIN_DETAILS?._id)
            }
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }, dispatch)
    };

    const addCard = async () => {

        let mandateFlag = false;
        clearErrorStates();
        mandateFlag = validateField(values.cardHolderName, setCardHolderNameErr) || mandateFlag;
        mandateFlag = validateField(values.cardNumber, setCardNumberErr) || mandateFlag;
        mandateFlag = validateField(values.expiryMonth, setExpiryMonthErr) || mandateFlag;
        mandateFlag = validateField(values.expiryYear, setExpiryYearErr) || mandateFlag;
        mandateFlag = validateField(values.cardCvv, setCardCvvErr) || mandateFlag;
        values.planID = planID
        setLoading(true);
        if (mandateFlag) {
            return
        }

        await axios.post(appConstants.baseURL + 'billing/addCard', values)
            .then(
                (res) => {
                    setLoading(false);
                    let response = res.data
                    console.log("response", response)


                }
            )
            .catch((error) => {
                setLoading(false);
                console.log("Error in cancelPlan=", error);
            }
            )
    };


    const cancelPlanUI = async () => {
        setMAinUi(false)
        setCancelPlanUIVisibility(true)

    };
    const handleCancel = name => event => {
        setDeleteDialogeFlag(false);
    };
    const handleCancel1 = name => event => {
        setDefaultDialogeFlag(false);
    };

    const handleLoading = (val) => {
        setLoading(val)
    };
    const handleDeleteDialogeClick = async (_id) => {
        setSelectedId(_id);
        setDeleteDialogeFlag(!deleteDialogeFlag);
    };
    const handleDefaultDialogeClick = async (_id) => {
        setSelectedId(_id);
        setDefaultDialogeFlag(!defaultDialogeFlag);
    };
    const handleDefaultCard = async (id) => {
        cardDeault();
        setDefaultDialogeFlag(!defaultDialogeFlag);
    };

    const handleDelete = async (id) => {
        deleteCard();
        setDeleteDialogeFlag(!deleteDialogeFlag);
    };
    const HandleAddPaymentMethod = async (id) => {
        setMAinUi(false)
        setPaymentMethodUi(true)
    };
    const cardDeault = async () => {
        try {
            for (let data of rows) {
                if (data.defaultCard === "Yes") {
                    if (data.paymentMethodID === selectedId) {
                        showResMsg(genericMessage.cardAlreadySetErr, 2000, false);
                        return
                    }

                }
            }
            values.paymentMethodID = selectedId;
            updateDefaultCard(values, (data) => {
                showResMsg(data.Result_Status ? genericMessage.cardDefault : data.Result_Message, 2000, data.Result_Status);
                if (data.Result_Status) setCustomerReload(!customerReload)
            }, dispatch)

        } catch (error) {
            setLoading(false)
            console.log("Catch in cardDeault API=", error)
        }
    };

    const deleteCard = async () => {
        try {
            for (let data of rows) {
                if (data.defaultCard === "Yes") {
                    if (data.paymentMethodID === selectedId) {
                        showResMsg(genericMessage.defaultCardErr, 2000, false);
                        return
                    }

                }
            }
            values.paymentMethodID = selectedId;

            cardDelete(values, (data) => {
                showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 2000, data.Result_Status);
                if (data.Result_Status) setCustomerReload(!customerReload)
            }, dispatch)

        } catch (error) {
            setLoading(false)
            console.log("Catch in deleteCard API=", error)
        }
    };

    useEffect(() => {
    }, [values.paymentMethodID])



    function changePlan() {
        setShowChangePLan(true);
        setScreenName("Change Subscription Plan")
        setMAinUi(false)
        setTransactionType("Subcription")
    }
    function showPricingPlanCard() {
        setShowChangePLan(false);
        setMAinUi(false)
    }
    const showCredits = async () => {
        setShowCredit(true)
        setScreenName("Add Credit")
        setMAinUi(false)
        setTransactionType("AddCredit")
    }
    useEffect(() => {
        if (values.noOfCredits !== "" && values.noOfCredits !== undefined) {
            setCreditCalculated(parseInt(values.noOfCredits) * parseInt(creditPerBuy))
        } else {
            setCreditCalculated(0)
        }
    }, [values.noOfCredits])

    const appearance = {
        theme: 'night',
        variables: {
            fontFamily: 'Sohne, system-ui, sans-serif',
            fontWeightNormal: '500',
            borderRadius: '8px',
            colorBackground: '#0A2540',
            colorPrimary: '#EFC078',
            accessibleColorOnColorPrimary: '#1A1B25',
            colorText: 'white',
            colorTextSecondary: 'white',
            colorTextPlaceholder: '#727F96',
            tabIconColor: 'white',
            logoColor: 'dark'
        },
        rules: {
            '.Input, .Block': {
                backgroundColor: '#202940',
                border: '1.5px solid var(--colorPrimary)'
            }
        }
    };


    const { tableBorder } = getColorMappings(sidenavColor);
    useEffect(() => {
        var element = document.getElementsByTagName('fieldset');
        let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
        var disabledval = document.querySelectorAll('.Mui-disabled');
        var dropicons = document.querySelectorAll('.MuiInputBase-root');
        for (let i = 0; i < element.length; i++) {

            element[i].style.borderColor = darkMode ? "white" : tableBorder;
        }

        for (let i = 0; i < labelShrink.length; i++) {
            labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
        }

        for (let i = 0; i < disabledval.length; i++) {
            var usevalue = disabledval[i].getElementsByTagName('input');

            if (usevalue.length > 0) {
                if (darkMode) {
                    usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");

                } else {
                    usevalue[0].style.removeProperty("-webkit-text-fill-color");
                }
            }
        }

        for (let i = 0; i < dropicons.length; i++) {
            var svgicon = dropicons[i].getElementsByTagName('svg');
            if (svgicon.length > 0) {
                if (darkMode) {
                    svgicon[0].setAttribute("style", "fill: white !important;");
                } else {
                    svgicon[0].setAttribute("style", "fill:");
                }
            }
        }
    }, [paymentMethodUi, showChangePlan, showCredit])





    let cardColumns = [
        {
            name: <p style={{ fontSize: "12px" }}>Expiry Month</p>,
            selector: row => row.cardNumber,
            sortable: true,
            sortField: 'Card Number',
        },
        {
            // name: "Expiry Month",
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Expiry Month</p>,
            selector: row => row.expiryMonth,
            sortable: true,
            sortField: 'Expiry Month',
            center: true,
        },
        {
            // name: "Default",
            name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Default</p>,
            selector: row => row.defaultCard,
            sortable: true,
            sortField: 'defaultCard',
            center: true,
        },
        {

            name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
            selector: row => row._id,
            center: true,
            cell: row => <IconMenu size="small" row={
                <>

                    {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
                    <Grid item style={{ width: "100%" }}>
                        <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDefaultDialogeClick(row.paymentMethodID)}
                        >
                            <TimelineItem
                                color="success"
                                icon={<EditIcon className="actionicon" />}
                                title="Edit"
                                onClick={() => handleDefaultDialogeClick(row.paymentMethodID)}

                            /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>

                    </Grid>
                    <Grid style={{ width: "100%" }} item>
                        <p style={darkMode ? { color: "white" } : { color: "black" }} onClick={() => handleDeleteDialogeClick(row.paymentMethodID)}>
                            <TimelineItem
                                color="error"
                                icon={<DeleteIcon className="actionicon" />}
                                onClick={() => handleDeleteDialogeClick(row.paymentMethodID)}
                                title="Delete"
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
                    </Grid>



                </>
            } />,
        },
    ]
    const waitUntilPlanExpire = () => {
        dispatch(loadingAction(true));
        showResMsg("Action not performed due to subscription cancellation. Contact the administrator for help.", 2000, false);
        setTimeout(() => {
            dispatch(loadingAction(false));
        }, 3000);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Height val={30} />
            {mainUi &&
                <Card>
                    <PageTitle screenName={screenName} />
                    <MDBox mt={1.5} >
                        <Grid container spacing={2}>
                            <Grid item xs={12} spacing={6}>
                                <Card sx={{ boxShadow: "none" }}>
                                    <MDBox pt={4} px={2.2}>
                                        <Grid container columnSpacing={5}>
                                            <Grid item xs={12} lg={3}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField type="text"
                                                            label="Subscription Plan (Active)"
                                                            variant="outlined"

                                                            fullWidth
                                                            inputProps={{
                                                                pattern: "^[0-9]+$",
                                                                maxLength: 5,
                                                                className: "custom-fieldtext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={details.planName}
                                                            // className={darkMode ? "whiteLabel" : "blackLabel"}

                                                            disabled
                                                        />
                                                    </MDBox>
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} lg={3}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField
                                                            type="text"
                                                            label="Activation Date"
                                                            variant="outlined"

                                                            fullWidth
                                                            inputProps={{
                                                                pattern: "^[0-9]+$",
                                                                maxLength: 5,
                                                                className: "custom-fieldtext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={details.planActivationDate}
                                                            disabled
                                                        />
                                                    </MDBox>
                                                </MDBox>
                                            </Grid>
                                            {details.planName !== "Silver" && !showCredit && cancellationRequest === "" &&
                                                <>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="Billing Cycle End Date"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        pattern: "^[0-9]+$",
                                                                        maxLength: 5,
                                                                        className: "custom-fieldtext"
                                                                    }}
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={details.planExpiryDate}
                                                                    disabled
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="New Billing Date"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        className: "custom-fieldtext"
                                                                    }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={details.planExpiryDate}
                                                                    fullWidth
                                                                    disabled
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                </>

                                            }

                                            {cancellationRequest !== "" && cancellationRequest !== undefined &&
                                                <>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="Plan Cancellation Request Date"
                                                                    style={{ height: "38.11px" }}
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        pattern: "^[0-9]+$",
                                                                        maxLength: 5,
                                                                        className: "custom-fieldtext"
                                                                    }}
                                                                    fullWidth

                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={cancellationRequest}
                                                                    disabled
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="Plan Cancellation Effective Date"

                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    inputProps={{
                                                                        className: "custom-fieldtext"
                                                                    }}
                                                                    value={planCancellationEffectiveDate}
                                                                    fullWidth
                                                                    disabled
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                </>
                                            }



                                        </Grid>
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                        {/* <CardContent mt={-3} > */}
                        <Grid container >
                            <Typography variant="h6" lg={12} mx={2} gutterBottom>
                                Cards Details
                            </Typography>
                        </Grid>
                        <BTable
                            columns={cardColumns}
                            data={rows}
                            selectableRows={false}
                            // onSort={handleSort}
                            //   sortingType={handleSort}
                            sortServer
                            pagination
                            paginationServer

                            fixedHeaderScrollHeight="410px"
                            fixedHeader={true}

                        />
                        {/* 
                        </CardContent> */}

                    </MDBox>
                </Card>


            }
            {mainUi &&
                <Grid
                    container
                    mt={2}
                    columnSpacing={4}
                    alignItems="center"
                    px={4}
                >

                    <Grid item xs={12} md={4} spacing={2} lg={2}>
                        <MDButton
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            color={disableColor || cancellationRequest ? "secondary" : "success"}
                            fullWidth
                            onClick={disableColor || cancellationRequest ? waitUntilPlanExpire : HandleAddPaymentMethod}
                        >
                            Add Payment Method
                        </MDButton>
                    </Grid>
                    <Grid item xs={12} md={6} spacing={2} lg={2}>
                        <MDButton
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            color={disableColor || cancellationRequest ? "secondary" : "success"}
                            onClick={disableColor || cancellationRequest ? waitUntilPlanExpire : changePlan}
                            fullWidth  >
                            Change Plan
                        </MDButton>
                    </Grid>
                    <Grid item xs={12} md={4} spacing={2} lg={2}>
                        <MDButton
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            onClick={disableColor || cancellationRequest ? waitUntilPlanExpire : showCredits}
                            color={disableColor || cancellationRequest ? "secondary" : "success"}
                            fullWidth  >
                            Add Credit
                        </MDButton>
                    </Grid>
                    <Grid item xs={12} md={4} spacing={2} lg={2}>
                        <MDButton
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            color={disableColor || cancellationRequest ? "secondary" : "success"}
                            onClick={() => navigate("/subscriptions/viewCredits")}
                            fullWidth  >
                            View Credit Use
                        </MDButton>
                    </Grid>
                    {featureAccess && <Grid item xs={12} md={4} spacing={2} lg={2} ml={"auto"}>
                        <MDButton
                            onClick={disableColor || cancellationRequest ? waitUntilPlanExpire : cancelPlanUI}
                            rel="noreferrer"
                            variant="gradient"
                            className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                            color={disableColor || cancellationRequest ? "secondary" : "warning"}
                            fullWidth  >
                            Cancel Subscription
                        </MDButton>
                    </Grid>}
                </Grid>
            }

            {cancelPlanUIVisibility &&
                <MDBox mt={6} mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} spacing={6}>
                            <Card sx={{ boxShadow: "none" }}>
                                <PageTitle screenName="Cancel Subscription Plan" />
                                <MDBox pt={4} pb={3} px={3}>

                                    <><Grid container columnSpacing={5}>
                                        <Grid item xs={12} lg={6}>
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Plan Cancellation Request Date"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled
                                                    inputProps={{
                                                        pattern: "^[0-9]+$",
                                                        maxLength: 7,


                                                        className: "custom-fieldtext"

                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    value={format(new Date(new Date()), 'LLL dd, yyyy')}
                                                    onChange={handleChange("planCancellationRequestDate")}

                                                />
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Plan Cancellation Effective Date"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                        inputProps={{
                                                            className: "custom-fieldtext"

                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={planCancellationEffectiveDate}



                                                    />
                                                </MDBox>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={12}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Subscription Cancellation Notes"
                                                        variant="outlined"
                                                        fullWidth
                                                        inputProps={{
                                                            className: "custom-fieldtext"

                                                        }}
                                                        value={values.planCancellationNotes}
                                                        onChange={handleChange("planCancellationNotes")}

                                                    />
                                                    {subscriptionCanNoteErr ? <span style={errMsg}> Subscription Cancellation Notes can't be blank</span> : ""}
                                                </MDBox>
                                            </MDBox>
                                        </Grid>
                                        <Grid
                                            container
                                            mt={2}
                                            columnSpacing={4}
                                            alignItems="center"
                                            display="flex"
                                            justifyContent="center"
                                        >
                                            <Grid item xs={12} md={4} spacing={2} lg={1.5}>


                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={exit}
                                                >
                                                    Cancel
                                                </MDButton>

                                            </Grid>
                                            <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                                                <MDButton
                                                    onClick={cancelPlan}
                                                    rel="noreferrer"
                                                    variant="gradient"
                                                    color="success"
                                                    fullWidth
                                                >
                                                    Cancel Plan
                                                </MDButton>
                                            </Grid>

                                        </Grid>
                                    </Grid></>
                                </MDBox>

                            </Card>
                        </Grid>
                    </Grid>


                </MDBox>

            }


            {(showChangePlan || showCredit) &&
                <MDBox mt={6} mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} spacing={6}>
                            <Card sx={{ boxShadow: "none" }}>
                                <PageTitle screenName={screenName} />
                                <MDBox pt={4} pb={3} px={2.2}>

                                    {showCredit ? <>
                                        <Grid spacing={2} container alignItems="center"
                                            display="flex"
                                            justifyContent="center" >
                                            <Grid item xs={12} lg={1.5}>
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Add Credit"
                                                        variant="outlined"
                                                        style={{ Width: "300px" }}
                                                        // fullWidth
                                                        inputProps={{
                                                            pattern: "^[0-9]+$",
                                                            maxLength: 7,
                                                            className: "custom-fieltext"
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.noOfCredits}
                                                        onChange={handleChange("noOfCredits")}

                                                    />
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} lg={1.5}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField
                                                            type="text"
                                                            label="Credit Value ($)"
                                                            variant="outlined"
                                                            style={{ Width: "300px" }}
                                                            // fullWidth
                                                            disabled
                                                            inputProps={{

                                                                className: "custom-fieltext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={creditCalculated}

                                                        />

                                                    </MDBox>
                                                </MDBox>
                                            </Grid>
                                        </Grid></> : <>
                                        <Grid container columnSpacing={5}>
                                            <Grid item xs={12} lg={3}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField type="text"
                                                            label="Subscription Plan"
                                                            variant="outlined"
                                                            fullWidth
                                                            inputProps={{
                                                                pattern: "^[0-9]+$",
                                                                maxLength: 5,
                                                                className: "custom-fieltext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={details.planName}
                                                            disabled

                                                        />


                                                    </MDBox>
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} lg={3}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField
                                                            type="text"
                                                            label="Activation Date"
                                                            variant="outlined"
                                                            fullWidth
                                                            inputProps={{
                                                                pattern: "^[0-9]+$",
                                                                maxLength: 5,
                                                                className: "custom-fieltext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={details.planActivationDate}
                                                            disabled
                                                        />
                                                    </MDBox>
                                                </MDBox>
                                            </Grid>
                                            {details.planName !== "Silver" &&
                                                <>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="Billing Cycle End Date"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        pattern: "^[0-9]+$",
                                                                        maxLength: 5,
                                                                        className: "custom-fieltext"
                                                                    }}
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={details.planExpiryDate}
                                                                    disabled
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox component="form" role="form">
                                                            <MDBox mb={4} xs={12}>
                                                                <TextField
                                                                    type="text"
                                                                    label="New Billing Date"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        className: "custom-fieltext"
                                                                    }}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={details.planExpiryDate}
                                                                    disabled
                                                                    fullWidth
                                                                />
                                                            </MDBox>
                                                        </MDBox>
                                                    </Grid>
                                                </>
                                            }

                                        </Grid>
                                        <Grid container columnSpacing={5}>
                                            <Grid item xs={12} lg={6}>
                                                <MDBox mb={4} xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">New Subscription Plan</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            style={{ height: "35.11px" }}
                                                            label="New Subscription Plan"
                                                            value={values.planID || ""}
                                                            disabled={showPaymentGateway}
                                                            onChange={handleChangePlan("planID")}
                                                        >
                                                            {plansList}
                                                        </Select>
                                                    </FormControl>
                                                </MDBox>
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <MDBox component="form" role="form">
                                                    <MDBox mb={4} xs={12}>
                                                        <TextField
                                                            type="text"
                                                            label="Plan Monthly cost ($)"
                                                            variant="outlined"
                                                            fullWidth
                                                            disabled
                                                            inputProps={{
                                                                pattern: "^[0-9]+$",
                                                                maxLength: 5,
                                                                className: "custom-fieldtext"
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={values.planMonthlyCost}

                                                        />

                                                    </MDBox>
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} lg={6}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    onClick={handleOpen}
                                                >
                                                    View Plans
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                    </>}





                                    {!showPaymentGateway ? <>
                                        <Grid
                                            container
                                            // columnSpacing={4}
                                            spacing={2}
                                            alignItems="center"
                                            display="flex"
                                            justifyContent="center"
                                        >
                                            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={exit}
                                                >
                                                    Cancel
                                                </MDButton>
                                            </Grid>

                                            {values.planName === "Silver" && !showCredit ? <>

                                                <Grid item xs={12} md={4} lg={1.2}>
                                                    <MDButton rel="noreferrer" variant="gradient" color="success" fullWidth
                                                        onClick={changeToTrial}
                                                    >
                                                        Submit
                                                    </MDButton>
                                                </Grid>

                                            </> : <>
                                                <Grid item xs={12} md={4} lg={1.2}>
                                                    <MDButton rel="noreferrer" variant="gradient" color="success" fullWidth
                                                        onClick={generatePaymentIntent}
                                                    >
                                                        Proceed
                                                    </MDButton>
                                                </Grid>
                                            </>}

                                        </Grid></> : <>
                                        <FormLabel id="demo-row-radio-buttons-group-label">Cards</FormLabel>

                                        <FormControl style={{ marginLeft: '20px' }} >

                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={handleChange1("cardType")}
                                                value={values1.cardType}
                                            >
                                                {rows.length > 0 &&
                                                    <FormControlLabel value="saveCard" control={<Radio />} label="Save Card" />
                                                }

                                                <FormControlLabel value="addCard" control={<Radio />} label="Add Card" />
                                            </RadioGroup>
                                        </FormControl>
                                        {values1.cardType === "saveCard" ? <>

                                            <Grid container>
                                                <Grid item lg={12} pt={2.5}>
                                                    <FormControl style={{ marginLeft: '20px' }}>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            onChange={handleChange("paymentMethodID")}
                                                            value={values.paymentMethodID}
                                                        >
                                                            {rows.map((val, i) => (
                                                                <FormControlLabel value={val.paymentMethodID} key={val.paymentMethodID} control={<Radio />} label={<VisaCard brand={val.brand} number={"************" + val.cardNumber} holder="jack peterson" expires={`${val.expiryMonth}/${val.expiryYear}`} />} />

                                                            ))}
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>


                                                <Grid
                                                    container
                                                    columnSpacing={4}
                                                    alignItems="center"
                                                    display="flex"
                                                    justifyContent="center"
                                                    pt={2.5}
                                                >

                                                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>

                                                        <MDButton
                                                            className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                            color="warning"
                                                            fullWidth
                                                            onClick={exit}
                                                        >
                                                            Cancel
                                                        </MDButton>

                                                    </Grid>

                                                    <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                                                        <MDButton
                                                            onClick={payWithSavedCard}
                                                            rel="noreferrer"
                                                            variant="gradient"
                                                            color="success"
                                                            fullWidth
                                                        >
                                                            Pay
                                                        </MDButton>
                                                    </Grid>



                                                </Grid>
                                            </Grid>


                                        </> : <>
                                            <Elements stripe={stripePromise} options={{
                                                clientSecret: paymentIntent.paymentClientSlient,
                                                appearance: darkMode ? appearance : {}
                                            }}>
                                                {showPaymentGateway ? <>
                                                    <CheckoutForm loading={handleLoading} planID={planID} oldPlanName={values.planName} oldPlanID={oldPlanID} transactionType={transactionType} />
                                                </> : ""}
                                            </Elements>


                                        </>}


                                    </>

                                    }





                                </MDBox>

                            </Card>
                        </Grid>
                    </Grid>


                </MDBox>

            }
            {/* {(showPricingPlan || showCredit) ? <>
                <Grid>

                </Grid>
            </>
            } */}
            {paymentMethodUi &&
                <>   <MDBox mt={6} mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} spacing={6}>
                            <Card sx={{ boxShadow: "none" }}>
                                <PageTitle screenName="Add Payment Method" />
                                <MDBox pt={4} pb={3} px={2.2}>
                                    <><Grid container columnSpacing={5}>
                                        <Grid item xs={12} lg={4}>
                                            <MDBox mb={4} xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Card Holder Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    inputProps={{
                                                        pattern: "^[A-Za-z ]+$",
                                                        maxLength: 30
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    value={values.cardHolderName}
                                                    onChange={handleChange("cardHolderName")} />
                                                {cardHolderNameErr ? <span style={errMsg}> Card Holder Name can't be blank</span> : ""}
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={8}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Card Number"
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="XXXX XXXX XXXX 1234"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={values.cardNumber}
                                                        onChange={handleChange("cardNumber")}

                                                    />
                                                    {cardNumberErr ? <span style={errMsg}> Card Number can't be blank</span> : ""}
                                                </MDBox>
                                            </MDBox>
                                        </Grid>

                                        <Grid item xs={12} lg={2}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Expiry Month"
                                                        variant="outlined"
                                                        inputProps={{

                                                            maxLength: 2,
                                                            pattern: '^[0-9]+$',
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        value={values.expiryMonth}
                                                        onChange={handleChange("expiryMonth")}
                                                    />
                                                    {expiryMonthErr ? <span style={errMsg}> Expiry Month can't be blank</span> : ""}

                                                </MDBox>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={2}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Expiry Year"
                                                        variant="outlined"

                                                        inputProps={{
                                                            maxLength: 4,
                                                            pattern: '^[0-9]+$',
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        value={values.expiryYear}
                                                        onChange={handleChange("expiryYear")}
                                                    />
                                                    {expiryYearErr ? <span style={errMsg}> Expiry Year can't be blank</span> : ""}

                                                </MDBox>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} lg={2}>
                                            <MDBox component="form" role="form">
                                                <MDBox mb={4} xs={12}>
                                                    <TextField
                                                        type="text"
                                                        label="Card Cvv"
                                                        variant="outlined"
                                                        inputProps={{
                                                            maxLength: 3,
                                                            pattern: '^[0-9]+$',
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                        fullWidth
                                                        value={values.cardCvv}
                                                        onChange={handleChange("cardCvv")}
                                                    />
                                                    {cardCvvErr ? <span style={errMsg}> Card Cvv can't be blank</span> : ""}

                                                </MDBox>
                                            </MDBox>

                                        </Grid>

                                        <Grid
                                            container
                                            mt={2}
                                            columnSpacing={4}
                                            alignItems="center"
                                            display="flex"
                                            justifyContent="center"
                                        >
                                            <Grid item xs={12} md={4} spacing={2} lg={1.5}>


                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    onClick={() => {
                                                        setMAinUi(true)
                                                        setPaymentMethodUi(false)
                                                        setValues((prevValues) => ({
                                                            ...prevValues,
                                                            cardCvv: "",
                                                            expiryYear: "",
                                                            expiryMonth: "",
                                                            cardNumber: "",
                                                            cardHolderName: "",
                                                        }));
                                                        setCardHolderNameErr(false)
                                                        setCardNumberErr(false);
                                                        setExpiryMonthErr(false);
                                                        setExpiryYearErr(false);
                                                        setCardCvvErr(false);
                                                    }}
                                                >
                                                    Cancel
                                                </MDButton>

                                            </Grid>
                                            <Grid item xs={12} md={4} spacing={2} lg={1.5}>
                                                <MDButton
                                                    onClick={addCard}
                                                    rel="noreferrer"
                                                    variant="gradient"
                                                    color="success"
                                                    fullWidth
                                                >
                                                    Add Card
                                                </MDButton>
                                            </Grid>

                                        </Grid>
                                    </Grid></>
                                </MDBox>

                            </Card>
                        </Grid>
                    </Grid>


                </MDBox></>
            }

            <DeleteModal
                open={deleteDialogeFlag}
                handleDelete={handleDelete}
                handleCancel={handleCancel("handleCancel")}
                closeModalClick={handleCancel("closeModalClick")}
            />





            {/* <Dialog open={openPlans} onClose={handleClose} maxWidth="lg"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        width: { xs: '100%', lg: '80%' }, // Responsive width
                        height: '620px', // Set height to 600px
                    }
                }}>
                <img src={PLAN} alt="Plans " />
                {/* <DialogContent>
                    <Button onClick={handleClose}>Close</Button>
                </DialogContent> */}
            {/* </Dialog> */}




            <Dialog
                open={openPlans}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        width: { xs: '100%', lg: '80%' },
                        height: '620px',
                        position: 'relative', // IMPORTANT
                    },
                }}
            >
                {/* Close Icon */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 10,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.7)',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Image */}
                <img
                    src={PLAN}
                    alt="Plans"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Dialog>


            <DeleteModal
                open={defaultDialogeFlag}
                message="Do you really want to set this Card as Default"
                handleDelete={handleDefaultCard}
                handleCancel={handleCancel1("handleCancel")}
                closeModalClick={handleCancel("closeModalClick")}
            />


            {/* <LoadingModal loading={loading} /> */}
        </DashboardLayout>
    );
}

export default BillingScreen;
